import { ActionTypes } from 'src/types/types';

export const FEATURE_NAME = 'selectedSite';

export const actionTypes = {
  GET_SELECTED_SITE: `${FEATURE_NAME}/GET_SELECTED_SITE`,
  FETCH_SITE_BY_ID: `${FEATURE_NAME}/FETCH_SITE_BY_ID`,
  UPDATE_SITE_DATA: `${FEATURE_NAME}/UPDATE_SITE_DATA`,
} satisfies ActionTypes<typeof FEATURE_NAME>;
